import { useStyles } from './styles';
import { Box, Button, Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import CancelIcon from '@material-ui/icons/Cancel';

export const LoanProcessedAlert = (props) => {
  const classes = useStyles();

  return (
    <Dialog  PaperProps={{ classes: { root: classes.dialogStyle }}} onClose={props.handleGotItBtn} open={true} className={classes.dialogClass}>
       <IconButton onClick={props.handleGotItBtn} className={classes.closeIcon}>
          <CancelIcon />
        </IconButton>
        <Box className={classes.root}>
          <Box className={classes.cardBody}>
            <Typography className={classes.statusTitle}>Selected Date Not Available</Typography>
          </Box>
        
          <Box className={classes.cardBodyContainer}>
            {(props.type == 'one-time') ?
            <>
              <Typography className={classes.records}>Updates are performed on your loan on the 1st and 2nd of every month. Payments cannot be scheduled for those days.</Typography>
              <Typography className={classes.records}>Please choose a different day for drafting your payment.</Typography>
            </> :
             <>
              <Typography className={classes.records}>To ensure updates on your loan apply prior to your draft, recurring drafting must be scheduled between the 3rd and the end of month.</Typography>
              <Typography className={classes.records}>Please select a day within that range.</Typography>
            </> }
          </Box>

          <Box className={classes.cardFooter}>
            <Button
              variant='contained'
              color='primary'
              className={classes.btn}
              onClick={() => props.handleGotItBtn()}
              >Got It</Button>
          </Box>
        </Box> 
    </Dialog>
  )
}
